import { render, staticRenderFns } from "./MakeClassScheduleFeed.vue?vue&type=template&id=97adfd4c&scoped=true&"
import script from "./MakeClassScheduleFeed.vue?vue&type=script&lang=js&"
export * from "./MakeClassScheduleFeed.vue?vue&type=script&lang=js&"
import style0 from "./MakeClassScheduleFeed.vue?vue&type=style&index=0&id=97adfd4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97adfd4c",
  null
  
)

export default component.exports